import { ChainId } from '@1inch-community/models';
// minimum 3s
export const averageBlockTime = {
    [ChainId.eth]: 11000,
    [ChainId.bnb]: 3000,
    [ChainId.matic]: 3000,
    [ChainId.op]: 3000,
    [ChainId.arbitrum]: 3000,
    [ChainId.gnosis]: 5000,
    [ChainId.avalanche]: 3000,
    [ChainId.fantom]: 3000,
    [ChainId.aurora]: 3000,
    [ChainId.klaytn]: 3000,
    [ChainId.zkSyncEra]: 3000,
};
//# sourceMappingURL=average-block-time.js.map